var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"alerts\"\u003E\u003Cuib-alert ng-repeat=\"alert in alerts\" type=\"{{alert.type}}\" dismiss-on-timeout=\"{{alert.timeout || 3000}}\" close=\"closeAlert($index)\"\u003E{{alert.msg}}\u003C\u002Fuib-alert\u003E\u003C\u002Fdiv\u003E\u003Ccookies-bar\u003E\u003C\u002Fcookies-bar\u003E\u003Cbutton class=\"btn background-waterblue\" id=\"newSCv2\" ng-click=\"openSelfcareV2()\"\u003EAller vers mon espace client\u003C\u002Fbutton\u003E\u003Cui-view\u003E\u003C\u002Fui-view\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/states/home/home.jade
// module id = 676
// module chunks = 1